"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixedDayjs = void 0;
const dayjs = require("dayjs");
const utc = require("dayjs/plugin/utc");
const timezone = require("dayjs/plugin/timezone");
dayjs.extend(utc);
dayjs.extend(timezone);
function fixedDayjs(date) {
    const normalized = date instanceof Date ? date : date.toLocaleString();
    return dayjs(normalized).locale('fr').tz('Europe/Paris', false);
}
exports.fixedDayjs = fixedDayjs;
//# sourceMappingURL=time.js.map